import React, { useContext, useEffect, useState } from "react";
import DATA from "./Data";
import { UserContext } from "./User";

const ProgressBar2 = ({
	label,
	background = "#e5e5e5",
	totalPoints = 0,
	// expected format for visual parts
	visualParts = [
		{
			percentage: 0,
			background: "white",
			text: "progress",
			points: "",
		},
	],
}) => {
	// Starting values needed for the animation
	// Mapped by "visualParts" so it can work with multiple values dynamically
	// It's an array of percentage widths
	const [widths, setWidths] = useState(
		visualParts.map(() => {
			return 0;
		})
	);
	const { user, setUser } = useContext(UserContext);

	const [rewards, setRewards] = useState(DATA.PACKETS);
	const [newTotalPoints, setNewTotalPoints] = useState(totalPoints);
	const [userPoints, setUserPoints] = useState(0);

	useEffect(() => {
		// https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
		// You need to wrap it to trigger the animation
		requestAnimationFrame(() => {
			// Set a new array of percentage widths based on the props
			setWidths(
				visualParts.map((item) => {
					return item.percentage;
				})
			);
		});
	}, [visualParts]);

	useEffect(() => {
		setRewards(DATA.REWARDS);
	}, [DATA]);

	useEffect(() => {
		setUserPoints(user.score);
		let price = 0;
		Object.values(DATA.PACKETS).map((packet) => {
			packet.activities.forEach((activity) => {
				price += parseInt(activity.points);
			});
		});
		setNewTotalPoints(price);
	}, [user, userPoints]);

	return (
		<div className="progress-bar-2">
			<div className="progressVisualRewards">
				{Object.values(DATA.REWARDS).map((reward, i) => {
					let percentage = (reward.price / newTotalPoints) * 100;
					return (
						<div
							style={{ left: percentage + "%" }}
							data-percentage={percentage}
							className={`progress-reward ${
								userPoints >= reward.price ? "active " + reward.id : reward.id
							}`}
						>
							<span>{reward.name}</span>
						</div>
					);
				})}
			</div>
			<div
				className="progressVisualFull"
				// to change the background color dynamically
				style={{
					background,
				}}
			>
				{visualParts.map((item, index) => {
					// map each part into separate div and each will be animated
					// because of the "transition: width 2s;" css in class "progressVisualPart"
					// and because of the new width ("widths[index]", previous one was 0)
					return (
						<div
							// There won't be additional changes in the array so the index can be used
							/* eslint-disable-next-line react/no-array-index-key */
							key={index}
							className={`progressVisualPart ${
								item.percentage >= 10 ? "show-text " : ""
							}`}
							data-modulestext={item.text}
							data-modulespoints={item.points}
							style={{
								width: widths[index] + "%",
								// setting the actual color of bar part
								background: item.background,
							}}
						></div>
					);
				})}
				<div className={`points-total ${userPoints >= 5 ? "show " : ""}`}>
					{userPoints}
				</div>
			</div>
		</div>
	);
};

export default ProgressBar2;
